<form [formGroup]="form" autocomplete="off" (ngSubmit)="reject()">
  <div mat-dialog-title>
    <h2>{{ 'rejectreportModal.rejectReport' | translate }} - {{ data.taskName }}</h2>
  </div>
  <mat-dialog-content class="mat-typography osc-ref-dialog__content">
    <input matInput type="text" hidden formControlName="id" id="id" />
    <mat-form-field>
      <mat-label>{{ 'rejectreportModal.reson' | translate }}</mat-label>
      <textarea matInput [placeholder]="'rejectreportModal.resonEx' | translate" formControlName="reason" id="reason"></textarea>
      <mat-hint align="end">{{ 'rejectreportModal.resonRequired' | translate }}</mat-hint>
      @if (hasError('reason', 'required')) {
        <mat-error>{{ 'rejectreportModal.resonRequired' | translate }}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button type="button" (click)="cancel()">{{ 'rejectreportModal.cancel' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" [ngClass]="{ 'osc-button--loading': onSaving }">
      {{ 'rejectreportModal.next' | translate }}
    </button>
  </mat-dialog-actions>
</form>
